import { Controller } from '@hotwired/stimulus';
import { useResizeObserver } from 'stimulus-library';

export default class extends Controller {
  static targets = ['wrapper', 'content', 'shadowLeft', 'shadowRight'];

  connect() {
    const content = this.contentTarget;

    content.addEventListener('scroll', this.onScroll.bind(this));
    useResizeObserver(this, this.wrapperTarget, this.onScroll.bind(this), { box: 'border-box' });
    this.onScroll();
  }

  onScroll() {
    const wrapper = this.wrapperTarget;
    const content = this.contentTarget;
    const shadowLeft = this.shadowLeftTarget;
    const shadowRight = this.shadowRightTarget;
    const contentScrollWidth = content.scrollWidth - wrapper.offsetWidth;
    const currentScroll = content.scrollLeft / contentScrollWidth;

    if (contentScrollWidth <= 0) {
      shadowLeft.style.opacity = 0;
      shadowRight.style.opacity = 0;
      return;
    }

    shadowLeft.style.opacity = currentScroll;
    shadowRight.style.opacity = 1 - currentScroll;
  }
}
